import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { DELETE } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_FAILURE,
  DELETE_DOCUMENT_SUCCESS,
  DeleteDocumentActionType,
  FETCH_DOCUMENTS
} from 'src/redux/documentsReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* DeleteDocumentFlow(action: DeleteDocumentActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/documents/${action.payload.id}`
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: DELETE,
      params: {
        type: action.payload.document_type
      }
    })
    yield put(DELETE_DOCUMENT_SUCCESS())
    yield put(
      FETCH_DOCUMENTS({
        ...(typeof action.payload.motorbikeId === 'string' ? { motorbikeId: action.payload.motorbikeId } : {}),
        ...(typeof action.payload.clientId === 'string' ? { clientId: action.payload.clientId } : {})
      })
    )
  } catch (error) {
    yield put(DELETE_DOCUMENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* DeleteDocumentSaga(): Generator<any, void, any> {
  yield takeLatest(DELETE_DOCUMENT, DeleteDocumentFlow)
}
